import Api from '@/api'

const FORMS_SCRIPT_URL = 'https://js.hsforms.net/forms/embed/v2.js'
const FORM_READY_TIMEOUT = 30000

class HubspotService {
  constructor () {
    this.scriptPromise = null
  }

  loadFormsScript () {
    if (window.hbspt?.forms) {
      return Promise.resolve(window.hbspt)
    }
    if (!this.scriptPromise) {
      this.scriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = FORMS_SCRIPT_URL
        script.async = true
        script.addEventListener('load', () => {
          if (window.hbspt?.forms) {
            resolve(window.hbspt)
          } else {
            this.scriptPromise = null
            reject(new Error('HubSpot forms script loaded without hbspt.forms'))
          }
        })
        script.addEventListener('error', () => {
          this.scriptPromise = null
          reject(new Error('HubSpot forms script failed to load'))
        })
        document.body.appendChild(script)
      })
    }
    return this.scriptPromise
  }

  async createContactForm (target) {
    const hbspt = await this.loadFormsScript()
    const formId = Api.hubspot.contact_form_id

    return new Promise((resolve, reject) => {
      const form = hbspt.forms.create({
        region: Api.hubspot.region,
        portalId: Api.hubspot.portal_id,
        formId,
        target
      })
      const timer = setTimeout(() => {
        reject(new Error('HubSpot form did not become ready in time'))
      }, FORM_READY_TIMEOUT)

      form.on('onFormReady', () => {
        clearTimeout(timer)
        resolve()
      })
      form.on('onRenderError', (name, error) => {
        clearTimeout(timer)
        reject(error instanceof Error ? error : new Error('HubSpot form failed to render'))
      })
    })
  }
}

export default new HubspotService()
